import React from "react";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import TeamLogo from "../../../team/components/TeamLogo";
import teamScoreStyles from "../../styles/TeamScore.styles";

const TeamScore = ({
	team,
	score = 0,
	reversed,
	name,
	onChange = () => {},
	onBlur = () => {},
	error,
	helperText,
	required
}) => {
	const classes = teamScoreStyles();

	return (
		<Box
			display="flex"
			spacing={2}
			justifyContent="center"
			alignItems="center"
			flexDirection={reversed ? "row-reverse" : "row"}
		>
			<TeamLogo team={team} hideName />
			<TextField
				required={required}
				type="number"
				variant="outlined"
				id={name}
				name={name}
				value={score}
				onChange={onChange}
				className={classes.score}
				error={error}
				helperText={helperText}
				onBlur={onBlur}
			/>
		</Box>
	);
};

export default TeamScore;
